interface StorageService {
  getItem(key: string): string | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setItem(key: string, value: any): void;
  removeItem(key: string): void;
  clear(): void;
}

class SafeStorageService implements StorageService {
  private readonly isAvailable: boolean;
  private memoryStorage: Record<string, string> = {};

  constructor() {
    this.isAvailable = this.checkAvailability();
  }

  private checkAvailability(): boolean {
    try {
      const testKey = '__storage_test__';
      localStorage.setItem(testKey, testKey);
      localStorage.removeItem(testKey);
      return true;
    } catch (e) {
      return false;
    }
  }

  getItem(key: string): string | null {
    if (this.isAvailable) {
      return localStorage.getItem(key);
    }
    return this.memoryStorage[key];
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setItem(key: string, value: any): void {
    const stringValue =
      typeof value === 'string' ? value : JSON.stringify(value);

    if (this.isAvailable) {
      localStorage.setItem(key, stringValue);
    }
    this.memoryStorage[key] = stringValue;
  }

  removeItem(key: string): void {
    if (this.isAvailable) {
      localStorage.removeItem(key);
    }
    delete this.memoryStorage[key];
  }

  clear(): void {
    if (this.isAvailable) {
      localStorage.clear();
    }
    this.memoryStorage = {};
  }
}

export const safeStorage = new SafeStorageService();
export default safeStorage;
